import BarChart from "../Charts/BarChart";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./SignupsSection.css";
import analyticsService from "../../../services/analyticsService";

function SignupsSection() {
  const [signupData, setSignupData] = useState({
    today: 0,
    yesterday: 0,
    week: 0,
    month: 0,
    lastMonth: 0,
  });
  const [activeData, setDeActive] = useState({
    today: 0,
    yesterday: 0,
    week: 0,
    month: 0,
    lastMonth: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await analyticsService.getDashboardAnalytics();

        if (response.success && response.data) {
          const { signups, deactivations } = response.data;

          if (signups) {
            setSignupData({
              today: signups.today || 0,
              yesterday: signups.yesterday || 0,
              week: signups.week || 0,
              month: signups.month || 0,
              lastMonth: signups.lastMonth || 0,
            });
          }

          if (deactivations) {
            setDeActive({
              today: deactivations.today || 0,
              yesterday: deactivations.yesterday || 0,
              week: deactivations.week || 0,
              month: deactivations.month || 0,
              lastMonth: deactivations.lastMonth || 0,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching signup analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const chartLabels = ["Today", "Yesterday", "Week", "Month", "Last Month"];
  const signupChartData = [
    signupData.today,
    signupData.yesterday,
    signupData.week,
    signupData.month,
    signupData.lastMonth,
  ];
  const deActiveChartData = [
    activeData.today,
    activeData.yesterday,
    activeData.week,
    activeData.month,
    activeData.lastMonth,
  ];
  return (
    <motion.div
      className="signups-section"
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="section-title">
        <h2>Account SignUp</h2>
        <span className="material-symbols-outlined">app_registration</span>
      </div>

      <div className="chart-wrapper">
        <BarChart
          labels={chartLabels}
          dataset1={signupChartData}
          dataset2={deActiveChartData}
          label1="SIGNUP"
          label2="DEACTIVATED"
        />
      </div>
    </motion.div>
  );
}

export default SignupsSection;
